/**
 * Created by lu on 2018/4/8.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    parent:require('../../../../view/swiper/SwiperItem'),
    slot:{
        inner:['html',{
            'class':''
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/banner/VideoItem.js
// module id = 528
// module chunks = 6